import React from "react";
import {
  Box,
  Typography,
  styled,
  Stack,
  List,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
  Divider,
  CircularProgress,
  Link,
} from "@mui/material";
import { COLORS } from "../../constants";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { SouthAfricanRand } from "../../utils/helpers";
import { ProductAvailability } from "../../utils/constants";
import { getSuggestedSearches } from "../../utils/searchSuggestions";

const SuggestionBlock = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "4px",
}));

const ResultsSuggestionsBlock = ({
  searchInput,
  loading,
  products,
  handleAddToCart,
}) => {
  const suggestedSearches = getSuggestedSearches(products, searchInput);

  return (
    <>
      <Box sx={{ display: "flex", p: 2, position: "relative" }}>
        {/* Left Section - Suggested Searches */}
        <Box sx={{ flex: 1.1, mr: 2 }}>
          <Typography
            variant="caption"
            sx={{ fontWeight: 500, color: "grey", mt: 0 }}
          >
            SUGGESTED SEARCHES
          </Typography>
          <Stack sx={{ mt: 2 }}>
            {suggestedSearches.length > 0 ? (
              suggestedSearches.map((suggestion, index) => (
                <Box key={index} sx={{ display: "block" }}>
                  <Link
                    href={suggestion.href}
                    variant="caption"
                    sx={{
                      display: "block",
                      textDecoration: "none",
                      cursor: "pointer",
                      color: COLORS.darkText,
                      padding: 1,
                      "&:hover": {
                        color: COLORS.primary,
                        backgroundColor: COLORS.themeYellow,
                      },
                    }}
                  >
                    {suggestion.label}
                  </Link>
                </Box>
              ))
            ) : (
              <Typography variant="caption" sx={{ padding: 1, color: "grey" }}>
                No suggestions available
              </Typography>
            )}
          </Stack>
        </Box>

        {/* Vertical Dividing Line */}
        <Box
          sx={{
            width: "1px",
            margin: "60px 20px 10px 0",
            backgroundColor: COLORS.border,
          }}
        />

        {/* Right Section - Results for ... */}
        <Box sx={{ flex: 2.5 }}>
          <Typography
            variant="caption"
            sx={{ fontWeight: 500, color: "grey", mt: 0, mb: 1 }}
          >
            Results for "{searchInput}"
          </Typography>
          <>
            {!!loading && (
              <Box
                sx={{
                  p: 4,
                  alignContent: "center",
                  textAlign: "center",
                }}
              >
                <CircularProgress />
              </Box>
            )}
            {!loading && (
              <List>
                {products && products.length > 0 ? (
                  products.map((item) => (
                    <React.Fragment key={item.sku}>
                      <ListItemButton
                        component="a"
                        href={`/product/${encodeURIComponent(item.sku)}`}
                        sx={{ p: 1.2 }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            alt={item.sku}
                            src={item.image}
                            sx={{
                              width: (theme) => theme.spacing(10),
                              height: (theme) => theme.spacing(10),
                            }}
                            imgProps={{
                              style: {
                                objectFit: "contain",
                              },
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          sx={{ lineHeight: 1 }}
                          primary={
                            <Typography variant="caption">
                              {item.name}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography
                                variant="subtitle1"
                                color={COLORS.themeRed}
                                fontWeight="500"
                                sx={{ mt: 0 }}
                              >
                                {SouthAfricanRand.format(item.price)}
                              </Typography>
                              {item.invoicePrice > 0 &&
                                item.invoicePrice !== item.itemPrice && (
                                  <Typography
                                    variant="subtitle2"
                                    color="textSecondary"
                                  >
                                    Invoice:{" "}
                                    {SouthAfricanRand.format(item.invoicePrice)}
                                  </Typography>
                                )}
                            </>
                          }
                        />
                        {item.availability !== ProductAvailability.No_Stock && (
                          <IconButton
                            color="error"
                            onClick={(e) => {
                              e.preventDefault();
                              handleAddToCart({
                                id: item.productId,
                                name: item.name,
                                vendor: item.vendor,
                                image: item.image,
                                sku: item.sku,
                              });
                            }}
                            sx={{
                              border: `1px solid ${COLORS.border}`,
                              borderRadius: "2px",
                            }}
                          >
                            <AddShoppingCartIcon
                              fontSize="small"
                              sx={{ color: COLORS.themeRed }}
                            />
                          </IconButton>
                        )}
                      </ListItemButton>
                      <Divider sx={{ borderColor: COLORS.border }} />
                    </React.Fragment>
                  ))
                ) : (
                  <ListItemText
                    sx={{ p: 1 }}
                    primaryTypographyProps={{ variant: "caption" }}
                  >
                    No products found. Please try another search term.
                  </ListItemText>
                )}
              </List>
            )}
          </>
        </Box>
      </Box>

      {/* Show More Results Button */}
      {/* {!loading && products && products.length > 0 && (
        <Link
          href={`/products?search=${encodeURIComponent(searchInput)}&count=${
            products.length
          }`}
          sx={{
            display: "block",
            width: "100%",
            backgroundColor: COLORS.themeYellow,
            color: COLORS.darkText,
            textAlign: "left",
            padding: 2,
            textDecoration: "none",
            "&:hover": {
              backgroundColor: COLORS.primary,
              color: COLORS.darkText,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="caption">Show More Results</Typography>
            <ChevronRightIcon sx={{ color: COLORS.darkText }} />
          </Box>
        </Link>
      )} */}
    </>
  );
};

export default ResultsSuggestionsBlock;
